/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Tue Sep 24 2024
 **/

import { useConfirm, usePopover, useSaveMyDesk } from "@/frameworks/core/hooks";
import { _T } from "@rfice/language";

import { POPOVER_ID } from "@/frameworks/core/commons";
import useSaveWidgetState from "./useSaveWidgetState";
import { useSetAtom } from "jotai";
import { EditState } from "@/frameworks/core/components";

export default function useWidget() {
	const popover = usePopover();
	const { confirm } = useConfirm();
	const { saveWidgetState } = useSaveMyDesk();
	const setWidgetEditState = useSetAtom(EditState);

	const { notificationState, recentFileState, totalShortcutList } = useSaveWidgetState();

	const saveWidget = () => {
		confirm(_T("현재 설정된 위젯으로 편집을 완료하시겠습니까?"), {
			onConfirm() {
				saveWidgetState(notificationState, recentFileState, totalShortcutList);
				setWidgetEditState(false);
				popover.hide(POPOVER_ID.SETTING_WIDGET);
			}
		});
	};

	return {
		saveWidget
	};
}
